var eventConstants = require('./events');

var DEFAULT_TIMEOUT = 700;

module.exports = {


    /**
     * Basic name for owl carousel custom swipe event
     */
    OWL_CAROUSEL_SWIPE_EVENT_NAME: ['swipe', eventConstants.CUSTOM_EVENT_NAMESPACE_KEYWORD, 'carousel'].join('.'),

    /**
     * Default timeout for carousel swipe triggered manually
     */
    DEFAULT_TIMEOUT: DEFAULT_TIMEOUT,

    /**
     *
     */
    RESPONSIVE_BREAKPOINT_SM_DOWN: 767,

    /**
     * This is configuration mapping object to set default navigation speed for carousels with different item count
     */
    NAVIGATION_SPEEDS: {
        1: DEFAULT_TIMEOUT,
        2: 450,
        3: 200
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/constant/carousel.js
// module id = 26
// module chunks = 36